import { render } from "./history-upload.vue?vue&type=template&id=b6e9cc52&ts=true"
import script from "./history-upload.vue?vue&type=script&lang=ts"
export * from "./history-upload.vue?vue&type=script&lang=ts"

import "./history-upload.vue?vue&type=style&index=0&id=b6e9cc52&lang=scss"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__